<template>
  <div class="app-container-v2 no-bg" v-loading="loading">
    <div class="w100 flex acenter mb24">
      <div class="flex acenter mr24" style="width: 340px; flex: 0 0 340px;">
        <img src="@/assets/img/v2/service-process/订单编号.png" class="size16 mr5" />
        <span class="font-20 fw-500 color-1c hpx22 text-nowrap">订单编号：{{ queryParams.orderId }}</span>
      </div>

      <div class="w100 flex jbetween pr24">
        <div class="flex acenter">
          <img src="@/assets/img/v2/service-process/工资月份.png" class="size16 mr5" />
          <span class="font-20 fw-500 color-1c hpx22">工资月份：{{ $day(queryParams.wageMonth).format('YYYY年M月') }}</span>
        </div>
        <el-button plain class="button-v2" @click="$back">返回列表</el-button>
      </div>
    </div>

    <div class="w100 flex">
      <div class="process-container flex vertical bg-white br6 mr24">
        <div v-for="item in processList" class="process-box flex vertical" :class="{ selected: processConfig[item].cardStatus === '选中', disabled: processConfig[item].cardStatus === '不可选' }" @click="changeProcess(item, currentProcess)">
          <div class="process-title flex acenter">
            <img :src="require(`@/assets/img/v2/service-process/${item}-${processConfig[item].cardStatus}.png`)" class="size30 mr12" />
            <span class="font-18 fw-600 color-3">{{ processConfig[item].name }}</span>
          </div>
          <div class="w100 pl12 mt13">
            <div class="process-info flex vertical pl28">
              <template v-if="processConfig[item].cardStatus !== '不可选'">
                <div v-for="config in processConfig[item].contentConfig" class="flex acenter hpx24 mb10">
                  <img src="@/assets/img/v2/service-process/状态.png" class="size14 mr8" />
                  <span class="font-14 color-6">{{ config.label }}：</span>
                  <div v-if="config.type === 'date'" class="font-14 fw-500 color-1c">{{ $day(processConfig[item].contentData.content[config.key]).format(config.format) }}</div>
                  <div v-else-if="config.type === 'status'" class="status-box flex center" :class="handleStatusBoxClass(processConfig[item].contentData.content[config.key])">{{ processConfig[item].contentData.content[config.key] }}</div>
                  <div v-else class="font-14 fw-500 color-1c">{{ processConfig[item].contentData.content[config.key] }}</div>
                </div>
                <div v-if="timeLabelMap[processConfig[item].contentData.status]" class="flex acenter hpx24 mb10">
                  <img src="@/assets/img/v2/service-process/时间.png" class="size14 mr8" />
                  <span class="font-14 color-6">{{ timeLabelMap[processConfig[item].contentData.status] }}：</span>
                  <span class="font-14 fw-500 color-1c">{{ processConfig[item].contentData.operTime }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <template v-if="processConfig.seg_00010003">
        <xzhs v-if="processConfig.seg_00010003.renderContent" v-show="processConfig.seg_00010003.showContent" :data="data" @refresh="getData"></xzhs>
        <fktz v-if="processConfig.seg_00020001.renderContent" v-show="processConfig.seg_00020001.showContent" :data="data" @refresh="getData"></fktz>
        <xzff v-if="processConfig.seg_00030003.renderContent" v-show="processConfig.seg_00030003.showContent" :data="data"></xzff>
        <fpkj v-if="processConfig.seg_00030004.renderContent" v-show="processConfig.seg_00030004.showContent" :data="data"></fpkj>
        <gssj v-if="processConfig.seg_00040001.renderContent" v-show="processConfig.seg_00040001.showContent" :data="data"></gssj>
        <gztff v-if="processConfig.seg_00050001.renderContent" v-show="processConfig.seg_00050001.showContent" :data="data"></gztff>
      </template>
    </div>

    <div v-if="rateModalShow" class="rate-modal-container flex vertical" v-loading="submitLoading">
      <div class="title-box">
        <span class="title-text">{{ rateModalTitle }}</span>
        <i class="el-icon-close font-16 color-3 pointer" @click="rateModalShow = false"></i>
      </div>
      <div class="rate-body flex vertical acenter p24">
        <el-rate class="relative mt40 mb40" v-model="rateForm.criticStar" show-text text-color="#666666" :disabled="rateDisabled"></el-rate>
        <span v-if="rateDisabled" class="hpx100 text-left color-6 mt20 overflow-y">{{ rateForm.criticRemark }}</span>
        <el-input v-else type="textarea" class="textarea-v2" v-model="rateForm.criticRemark" placeholder="服务怎么样，说说您的感受吧～" maxlength="2000" :rows="4" />
      </div>
      <div v-if="!rateDisabled" class="w100 flex jend acenter pr24 absolute" style="bottom: 24px;">
        <el-button type="primary" class="button-v2" @click="saveRate">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/order'
import { processContentConfig, timeLabelMap } from './config'
import xzhs from './components/薪资核算.vue'
import fktz from './components/付款通知.vue'
import fpkj from './components/发票开具.vue'
import xzff from './components/薪资发放.vue'
import gssj from './components/个税申缴.vue'
import gztff from './components/工资条发放.vue'

export default {
  name: 'ServiceProcessOrderDetail',
  components: {
    xzhs, fktz, fpkj, xzff, gssj, gztff
  },
  data() {
    return {
      loading: true,
      queryParams: {
        orderId: undefined,
        wageMonth: undefined
      },
      processList: [],
      currentProcess: '',
      processConfig: {},
      timeLabelMap: timeLabelMap,
      data: {
        orderInfo: {}
      },
      rateModalShow: false,
      rateModalTitle: '',
      rateForm: {
        criticStar: 5,
        criticRemark: ''
      },
      rateDisabled: true,
      submitLoading: false
    }
  },
  computed: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryParams.orderId = this.$route.query.orderId
      this.queryParams.wageMonth = this.$route.query.wageMonth
      this.getData()
    },
    reset() {
      this.currentProcess = ''
      this.processList = []
      this.processConfig = {}
    },
    getData() {
      this.loading = true
      this.reset()
      api.selectOrderDetailForView(this.queryParams).then(res => {
        this.data = res.data.data
        this.handleData()
        this.loading = false
      })
    },
    handleData() {
      // 订单信息处理
      if (this.$isNotEmpty(this.data.orderInfoAttr)) {
        this.data.orderInfo.fileList = []
        this.data.orderInfo.addFileList = []
        for (let fileItem of this.data.orderInfoAttr) {
          fileItem.name = fileItem.fileName
          fileItem.isAdd === '10020001' ? this.data.orderInfo.addFileList.push(fileItem) : this.data.orderInfo.fileList.push(fileItem)
        }
      }
      if (this.$isNotEmpty(this.data.orderInfoRemark)) {
        this.data.orderInfo.addRemarkList = []
        for (let remarkItem of this.data.orderInfoRemark) {
          remarkItem.isAdd === '10020001' ? this.data.orderInfo.addRemarkList.push(remarkItem) : this.data.orderInfo.remark = remarkItem.remark
        }
      }
      // 流程数据处理
      this.currentProcess = this.data.currentSeg
      this.data.logs.forEach(item => {
        item.content = item.rejectReason ? JSON.parse(item.rejectReason) : {}
        for (let contentKey in item.content) {
          if (contentKey.includes('状态')) {
            item.status = item.content[contentKey]
          }
        }
        // 如果是工资条发放的流程且工资条已发放，则展示评价弹窗
        if (item.segNum === 'seg_00050001' && item.status === '已发放') {
          this.getRate()
        }
      })
      let contentMap = this.$arrayToObj(this.data.logs, 'segNum')
      let processConfig = {}, defaultStatus = '可选'
      this.data.allSeg.forEach(item => {
        this.processList.push(item.codeItemId)
        let cardStatus = defaultStatus
        if (item.codeItemId === this.currentProcess) {
          cardStatus = '选中'
          defaultStatus = '不可选'
        }
        processConfig[item.codeItemId] = {
          name: item.codeItemName,
          cardStatus,
          renderContent: false,
          showContent: false,
          contentConfig: processContentConfig[item.codeItemId],
          contentData: contentMap[item.codeItemId]
        }
      })
      processConfig[this.currentProcess].renderContent = true
      processConfig[this.currentProcess].showContent = true
      this.processConfig = processConfig
      console.log(processConfig)
    },
    changeProcess(newProcess, oldProcess) {
      if (newProcess === oldProcess || this.processConfig[newProcess].cardStatus === '不可选') return
      this.processConfig[oldProcess].cardStatus = '可选'
      this.processConfig[oldProcess].showContent = false
      this.processConfig[newProcess].cardStatus = '选中'
      this.processConfig[newProcess].renderContent = true
      this.processConfig[newProcess].showContent = true
      this.currentProcess = newProcess
    },
    handleStatusBoxClass(status) {
      if (status === '算薪中') return 'blue'
      if (status === '待付款') return 'orange'
      if (status.includes('已')) return 'green'
    },
    getRate() {
      api.getOrderCriticalInfo({orderId: this.queryParams.orderId}).then(res => {
        if (res.data.code === 0) {
          // 评价数据为空则说明未评价过，展示评价表单
          if (this.$isEmpty(res.data.data)) {
            this.rateModalTitle = '请您对本月服务进行评价'
            this.rateForm = {
              orderId: this.queryParams.orderId,
              criticStar: 5,
              criticRemark: ''
            }
            this.rateDisabled = false
            this.rateModalShow = true
          } else {
            this.rateModalTitle = '我的评价'
            this.rateForm = res.data.data[0]
            this.rateDisabled = true
            this.rateModalShow = true
          }
        }
      })
    },
    saveRate() {
      this.submitLoading = true
      api.setOrderCriticalInfo(this.rateForm).then(res => {
        if (res.data.code === 0) {
          this.rateModalTitle = '我的评价'
          this.rateDisabled = true
          this.$msgSuccess('评价成功')
        }
      }).finally(() => this.submitLoading = false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.process-container {
  width: 340px;
  flex: 0 0 340px;
  height: calc(100vh - 152px);
  overflow-y: auto;

  .process-box {
    width: 100%;
    height: 200px;
    flex: 0 0 200px;
    background: #FFFFFF;
    padding: 24px 0 0 24px;
    cursor: pointer;

    .process-info {
      height: 150px;
      border-left: 1px dashed rgba(255, 150, 0, 0.80);

      .status-box {
        width: 56px;
        height: 24px;
        background: rgba(190,203,217,0.2);
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #586778;

        &.blue {
          background: rgba(0,95,255,0.08);
          color: #005FFF;
        }
        &.orange {
          background: rgba(255,136,0,0.08);
          color: #FF8800;
        }
        &.green {
          background: rgba(3,178,0,0.08);
          color: #03B200;
        }
      }
    }

    &.selected {
      background: url('~@/assets/img/v2/service-process/选中背景.png') no-repeat;
      background-size: 100% 200px;

      .process-title {
        color: #FF8C00;
      }
    }
    &.disabled {
      cursor: not-allowed;

      .process-title {
        color: #999999;
      }
      .process-info {
        border-left: 1px dashed rgba(159,159,159,0.8);
      }
    }
    &:last-child {
      .process-info {
        height: 133px;
      }
    }
  }
}
.rate-modal-container {
  z-index: 100;
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 400px;
  height: 380px;
  background: #FFFFFF;
  box-shadow: 0 0 20px 0 rgba(0,0,0,0.1);
  border-radius: 6px;

  .rate-body {
    ::v-deep .el-rate {
      .el-rate__item {
        .el-rate__icon {
          font-size: 40px;
          margin-right: 30px;
        }
        &:nth-last-child(2) {
          .el-rate__icon {
            margin-right: 0;
          }
        }
      }
      .el-rate__text {
        position: absolute;
        top: -38px;
        width: 100%;
        text-align: center;
        left: 0;
        font-size: 18px;
      }
    }
  }
}
</style>
